// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qZRp","content":"styles_content__3wAt1","row":"styles_row__D7LhY","footer":"styles_footer__36wBC","phraseLength":"styles_phraseLength__1Edpd"};